import { ForumsPageProps } from 'src/types/NextApp';
import { PageType } from 'src/types/server/PageType';
import { AppState } from 'src/redux/store';
import { userInfoActions } from 'src/redux/slices/userInfo';
import { threadDetailActions } from 'src/redux/slices/threadDetailSlice';
import { groupsActions } from 'src/redux/slices/groups';
import { notificationsActions } from 'src/redux/slices/notifications';
import { weblabActions } from 'src/redux/slices/weblab';
import { AnyAction, CombinedState, ThunkDispatch } from '@reduxjs/toolkit';
import { threadCategoriesActions } from 'src/redux/slices/threadCategories';
import * as postSearchActions from './slices/postSearch';
import { SearchType } from './slices/postSearch';

const setSSRPageData = (
  pageProps: ForumsPageProps,
  dispatch: ThunkDispatch<CombinedState<AppState>, undefined, AnyAction>,
): void => {
  switch (pageProps.pageType) {
    case PageType.notifications:
      dispatch(userInfoActions.setUserInfoState(pageProps.userData));
      dispatch(groupsActions.setGroupsState({ groups: pageProps.groups }));
      dispatch(notificationsActions.setNotificationsState(pageProps.notificationsData));
      dispatch(
        notificationsActions.setNotificationsCountState({
          unreadCount: pageProps.unreadCount,
        }),
      );
      dispatch(weblabActions.setWeblabList(pageProps.weblabList));
      break;
    case PageType.threadDetail:
      dispatch(userInfoActions.setUserInfoState(pageProps.userData));
      dispatch(groupsActions.setGroupsState({ groups: pageProps.groups }));
      if (pageProps.threadData) {
        dispatch(threadDetailActions.setThreadDetailState(pageProps.threadData));
      }
      dispatch(threadCategoriesActions.setCategoriesState(pageProps.categories));
      dispatch(
        notificationsActions.setNotificationsCountState({
          unreadCount: pageProps.unreadCount,
        }),
      );
      dispatch(weblabActions.setWeblabList(pageProps.weblabList));
      break;
    case PageType.homepage:
      dispatch(userInfoActions.setUserInfoState(pageProps.userData));
      dispatch(threadCategoriesActions.setCategoriesState(pageProps.categories));
      dispatch(
        notificationsActions.setNotificationsCountState({
          unreadCount: pageProps.unreadCount,
        }),
      );
      dispatch(postSearchActions.setSearchState({
        type: SearchType.pinnedThreads,
        response: pageProps.pinnedThreads,
      }));
      dispatch(postSearchActions.setSearchState({
        type: SearchType.threadListing,
        response: pageProps.threadListings,
      }));
      dispatch(weblabActions.setWeblabList(pageProps.weblabList));
      break;
    default:
      break;
  }
};
export default setSSRPageData;
